/**
 * Holds the handlers for the client event emitter
 * @module
 */
var _ = require('optimizely-client-fn');
var actionTypes = require('../constants/action_types');

var SEP = '|';

/**
 * Create event handler key based on filter
 * @private
 * @param {Object?} filter
 * @param {string?} filter.type
 * @param {string?} filter.name
 * @return {string}
 */
function createKey(filter:any): string {
  var keyParts = [];
  if (!filter || !_.isObject(filter)) {
    return SEP;
  }

  if (filter.type) {
    keyParts.push(filter.type);
  }
  keyParts.push(SEP);
  if (filter.type && filter.name) {
    keyParts.push(filter.name);
  }

  return keyParts.join('');
}

module.exports = {
  initialize: function() {
    this.__state = {
      handlers: {},
    };

    this.on(actionTypes.ADD_EMITTER_HANDLER, this.__addHandler);
    this.on(actionTypes.REMOVE_EMITTER_HANDLER, this.__removeHandler);
  },

  /**
   * @param {Object} event
   * @param {string} event.type
   * @param {string} event.name
   * @param {boolean?} isInternal
   * @return {HandlerEntry[]}
   */
  getHandlers: function(event:any, isInternal:boolean): Function[] {
    // TODO(tyler): it's possible this will deliver duplicate handlers if event.name is falsy,
    // or both event.name and event.type are falsy
    var filtersToCheck = [
      null, // events registered with no filter
      { type: event.type },  // events registered filtered by type
      { type: event.type, name: event.name }, // filtered by type and name
    ];

    var handlerEntries = [];
    _.each(filtersToCheck, _.bind(function(filter) {
      var key = createKey(filter);
      var handlersForKey = this.__state.handlers[key];
      if (handlersForKey) {
        handlerEntries = handlerEntries.concat(handlersForKey);
      }
    }, this));

    if (isInternal) {
      handlerEntries = _.filter(handlerEntries, function(entry) {
        // if its an internal event we dont want to call public handlers
        return !entry.publicOnly;
      });
    }

    // return an array of handler functions
    return handlerEntries;
  },

  /**
   * @private
   * @param {Object} payload
   * @param {Function} payload.handler
   * @param {Object?} payload.filter
   * @param {boolean} payload.isInternal
   * @param {string} payload.token
   */
  __addHandler: function(payload:any) {
    var key = createKey(payload.filter);

    if (!this.__state.handlers[key]) {
      this.__state.handlers[key] = [];
    }

    // add entry
    this.__state.handlers[key].push({
      handler: payload.handler,
      token: payload.token,
      publicOnly: !!payload.publicOnly,
      emitErrors: !!payload.emitErrors,
    });
    this.emitChange();
  },

  /**
   * @private
   * @param {Object} payload
   * @param {string} payload.token
   */
  __removeHandler: function(payload:any) {
    var removed = false;
    var token = payload.token;
    _.forOwn(this.__state.handlers, _.bind(function(handlerEntries, key) {
      var filteredHandlerEntries = _.filter(handlerEntries, function(entry) {
        return entry.token !== token;
      });
      if (filteredHandlerEntries.length !== handlerEntries.length) {
        removed = true;
        this.__state.handlers[key] = filteredHandlerEntries;
      }
    }, this));
    if (removed) {
      this.emitChange();
    }
  },
};
